import { render, staticRenderFns } from "./MusicNote.vue?vue&type=template&id=6564ffda"
import script from "./MusicNote.vue?vue&type=script&lang=js"
export * from "./MusicNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports